export default __webpack_public_path__ + "static/media/loading.77dd8198.gif";